import { proto as vibeProto } from '../../proto/AsrProto';
import { proto as listenerProto } from '../../proto/ListenerProto';

export class Recorder {
    onAudioData: (audio: Uint8Array) => void;
    onStop: () => void;
    _electronRecorderHooksInited?: boolean;

    constructor(onAudioData: (audio: Uint8Array) => void, onStop: () => void) {
        this.onAudioData = onAudioData;
        this.onStop = onStop;
    }

    start() {
        this.stop();
        const electronAPI = window.electronAPI;
        if (electronAPI) {
            electronAPI.startRecording({});

            if (!this._electronRecorderHooksInited) {
                electronAPI.onRecorderChunk((chunk: Uint8Array) => {
                    const audioChunk = vibeProto.AudioChunkWithMetadata.decode(chunk);

                    if (audioChunk.channel === listenerProto.DataFlow.CAPTURE) {
                        this.onAudioData(audioChunk.audioChunk);
                    }
                });

                electronAPI.onRecorderStopped(() => {
                    this.onStop();
                });

                this._electronRecorderHooksInited = true;
            }
        }
    }

    stop() {
        const electronAPI = window.electronAPI;
        if (electronAPI?.stopRecording) {
            electronAPI.stopRecording();
        }
    }
}
